import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalibrationUsesLabelModel } from '../../../../models';
import ICalibrationUsesLabel = ZoneIQCalibration.ICalibrationUsesLabel;
import { CommonService } from '../../../../../shared/services/common.service';
import { ImportService } from 'src/app/core/services/import.service';
import IUseClass = ZoneIQCalibration.IUseClass;
import * as _ from 'lodash';
import ICalibrationUsesType = ZoneIQCalibration.ICalibrationUsesType;
import { ZoningCodeService } from 'src/app/core/services';
import { CalibrationUsesLabelsMap } from 'src/app/interfaces/calibration-uses-labels-map';

export interface IUseLabelEditData {
    tables: CalibrationUsesLabelsMap;
    usesType?: ICalibrationUsesType;
    zoningCodeId: number;
    index?: number;
    use?: ICalibrationUsesLabel;
}

@Component({
    standalone: false,
    selector: 'app-edit-uses-popup',
    templateUrl: './edit-uses-popup.component.html',
    styleUrls: ['./edit-uses-popup.component.scss']

})
export class EditUsesPopupComponent implements OnInit {
    selectedUseType: ICalibrationUsesType;
    usesTypes: ICalibrationUsesType[] = [];
    table: CalibrationUsesLabelsMap;
    validLabelName = false;
    importErrors = '';
    useClassOptions: IUseClass[] = [];
    originalUse: ICalibrationUsesLabel;
    currentUse: ICalibrationUsesLabel;

    get isExistingUseLabel() {
        return this.data ? !!this.data.usesType : false;
    }

    constructor(
        private commonService: CommonService,
        private importService: ImportService,
        private zcService: ZoningCodeService,
        public dialogRef: MatDialogRef<EditUsesPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IUseLabelEditData
    ) {
        this.usesTypes = this.zcService.selectedZoningCode.CalibrationUsesTypes;
    }

    ngOnInit() {
        const data = this.data;
        this.table = this.data.tables;
        this.originalUse = this.data.use || this.getDefaultUseLabel();
        this.currentUse = _.cloneDeep(this.originalUse);
        if (data.usesType) {
            this.selectedUseType = data.usesType || null;
            this.validLabelName = true;
        }
        this.useClassOptions = this.zcService.useClasses;
    }

    checkValidation(value: string) {
        this.validLabelName = this.commonService.checkEmptyString(value);
        this.importErrors = '';
    }

    changeUses() {
        this.importErrors = this.importService.getUsesLabelErrors(
            this.currentUse.Label,
            this.data.index,
            _.get(this.data, 'usesType.Name')
        );
        this.validLabelName = !this.importErrors;
        if (!this.validLabelName) {
            return;
        }
        const data = this.data;
        this.originalUse.Label = this.currentUse.Label.trim();
        this.originalUse.CalibrationUsesTypeId = this.selectedUseType.Id;
        this.originalUse.ClassId = this.currentUse.ClassId;
        let movedUses: ICalibrationUsesLabel[] = [this.originalUse];
        if (this.isExistingUseLabel) {
            movedUses = this.table[data.usesType.Name].splice(this.data.index, 1);
            if (!this.table[data.usesType.Name].length) {
                delete this.table[data.usesType.Name];
            }
        }

        this.table[this.selectedUseType.Name] = this.table[this.selectedUseType.Name]
            ? [...this.table[this.selectedUseType.Name], ...movedUses]
            : [...[], ...movedUses];

        this.table[this.selectedUseType.Name].sort(CalibrationUsesLabelModel.sortingUsesLabel);
        this.importService.validateUsesLabels();
        this.dialogRef.close();
    }

    getDefaultUseLabel(): ICalibrationUsesLabel {
        return {
            ClassId: this.useClassOptions[0].Id,
            Label: '',
            ZoningCodeId: this.data.zoningCodeId
        };
    }
}
